import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CustomObjectEntityModel} from "../custom-object-entity.model";
import {CustomObjectSearchModel} from "../custom-object-search.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-custom-object-search-page",
    templateUrl: "custom-object-search-page.component.html",
    providers: [provideSearchModel(CustomObjectSearchModel), provideEntityModel(CustomObjectEntityModel)]
})
export class CustomObjectSearchPageComponent extends AbstractSearchPage {

    productLineContext: boolean = false;
    inventoryContext: boolean = false;
    outletContext: boolean = false;
    membershipTypeContext: boolean = false;

    constructor(private searchModel: CustomObjectSearchModel) {
        super();
    }

    prepareInitialFilter(): void {
        if (this.isSelectMode() && this.extendedSearchParams.searchParams) {
            this.searchModel.filter["customObjectTypeId"] = this.extendedSearchParams.searchParams["customObjectTypeId"];
            this.searchModel.filter["excludeCustomObjectTypeId"] = this.extendedSearchParams.searchParams["excludeCustomObjectTypeId"];
        }
    }
}
